import { Injectable } from '@angular/core';
import '../../node_modules/rxjs/add/operator/map';
import { UtilService } from '../services/util.service';
import { AxiosHttpRequest } from '../infra/axioshttprequest';

@Injectable()
export class ProductService{
    url: string;
    protocol: string;

    constructor(
        private axiosHttpRequest: AxiosHttpRequest
        , private util: UtilService) 
    {
        if (location.protocol == 'file:') this.protocol = 'https:';
        else this.protocol = location.protocol;
    }

    retrieveProductList(
        pageNum: number
        , salesrepCode: string
        , shiptoCode: string
        , soldtoCode: string
        , salesorg: string
        , division: string
        , distchannel: string
        , searchTerm: string
        , prdGrpCode: string
        , prdSubGrpCode: string
        , prdShowBonus: string
        , prdShowMustSell: string
        , sales_ind: string
        , setting_id: string
        , orderType: string
        , mat_gr_4:string
        , contractNo?: string
    ) {
        const params: any = {
            pageIndex: pageNum.toString()
            , salesrepCode: salesrepCode
            , shiptoCode: shiptoCode
            , soldtoCode: soldtoCode
            , salesorg: salesorg
            , division: division
            , distchannel: distchannel
            , searchTerm: encodeURIComponent(searchTerm)
            , prdGrpCode: prdGrpCode
            , prdSubGrpCode: prdSubGrpCode
            , prdShowBonus: prdShowBonus
            , prdShowMustSell: prdShowMustSell
            , sales_ind: sales_ind
            , setting_id: setting_id
            , orderType: orderType
            , mat_grp_4: mat_gr_4
        };

        if (contractNo) {
            params.contractNo = contractNo;
        }
        
        this.url = this.protocol + this.util.getWebServiceURL() + 'product/GetProductList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveProductPrice(
        prdCode: string
        , uomCode: string
        , shiptoCode: string
        , soldtoCode: string
        , salesorg: string
        , division: string
        , distchannel: string
        , setting_id: string
        , orderType: string
    ) {
        const params = {
            prdCode: prdCode
            , uomCode: uomCode
            , soldtoCode: soldtoCode
            , shiptoCode: shiptoCode
            , salesorg: salesorg
            , division: division
            , distchannel: distchannel
            , setting_id: setting_id
            , orderType: orderType
        };
        
        this.url = this.protocol + this.util.getWebServiceURL() + 'product/GetProductPrice';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveStockLevel(
        strPrdCode:string
        , strPlant:string
        , setting_id: string
        , strSloc:string
    ) {
      const params = {
        strPrdCode: strPrdCode
        , strPlant: strPlant
        , setting_id: setting_id
        , strSloc: strSloc
      };
      
      this.url = this.protocol + this.util.getWebServiceURL() + 'product/GetStockLevelList';
      return this.axiosHttpRequest.get(this.url, params);
    }

    // TODO: salesInd is always determined?
    retrieveLineTypeList(
        setting_id: string
        , salesInd?: string
    ) {
        const params = {
            setting_id: setting_id
            , salesInd: salesInd
        };
        
        this.url = this.protocol + this.util.getWebServiceURL() + 'product/GetLineTypeList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrievePrdGrpList(
        salesrepCode: string
        , setting_id: string
    ) {
        const params = {
            salesrepCode: salesrepCode
            , setting_id: setting_id
        };
       
        this.url = this.protocol + this.util.getWebServiceURL() + 'product/GetPrdGrpList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrievePrdSubGrpList(
        salesrepCode: string
        , prdGrpCode: string
        , setting_id: string
    ) {
        const params = {
            salesrepCode: salesrepCode
            , prdGrpCode: prdGrpCode
            , setting_id: setting_id
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'product/GetPrdSubGrpList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrievePlantList(
        setting_id: string
        , salesrep_code: string
    ) {
        const params = {
            setting_id: setting_id
            , salesrep_code: salesrep_code
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'product/GetPlantList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveStockLocationByPlantList(
        setting_id: string
        , salesrep_code:string
        , plant:string
    ) {
        const params = {
            setting_id: setting_id
            , salesrep_code: salesrep_code
            , plant: plant
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'product/GetStockLocationByPlant';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveBomProductList(
        salesrepCode: string
        , soldtoCode: string
        , shiptoCode: string
        , salesorg: string
        , division: string
        , distchannel: string
        , sales_ind: string
        , setting_id: string
        , prd_code: string
        , order_type: string
    ) {
        const params = {
            salesrepCode: salesrepCode
            , shiptoCode: shiptoCode
            , soldtoCode: soldtoCode
            , salesorg: salesorg
            , division: division
            , distchannel: distchannel
            , sales_ind: sales_ind
            , setting_id: setting_id
            , prd_code: prd_code
            , order_type: order_type
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'product/GetBomProductList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveChidlrenProductForBomList(
        salesrepCode: string
        , soldtoCode: string
        , shiptoCode: string
        , salesorg: string
        , division: string
        , distchannel: string
        , sales_ind: string
        , setting_id: string
        , order_type: string
        , searchValue: string
        , pageIndex: number
    ) {
        const params = {
            salesrepCode: salesrepCode
            , shiptoCode: shiptoCode
            , soldtoCode: soldtoCode
            , salesorg: salesorg
            , division: division
            , distchannel: distchannel
            , sales_ind: sales_ind
            , setting_id: setting_id
            , order_type: order_type
            , searchValue: searchValue
            , pageIndex: pageIndex.toString()
        };

        this.url = this.protocol + this.util.getWebServiceURL() + 'product/GetChildrenForBomProductList';
        return this.axiosHttpRequest.get(this.url, params);
    }

    getProductExipryDate(
        prd_ids: string[]
        , setting_id: string
    ) {
        const params = {
            setting_id: setting_id
            , prd_codes: prd_ids
        }

        this.url = this.protocol + this.util.getWebServiceURL() + 'product/GetProductExipryDate';
        return this.axiosHttpRequest.post(this.url, params);
    }

    getSurchargeProduct(setting_id: string) {
        const params = {
            setting_id: setting_id
        }

        this.url = this.protocol + this.util.getWebServiceURL() + 'product/GetSurchargeProduct';
        return this.axiosHttpRequest.get(this.url, params);
    }

    retrieveProductMOV(
        salesrepCode: string
        , shiptoCode: string
        , soldtoCode: string
        , salesorg: string
        , division: string
        , distchannel: string
        , prdCode: string
        , sales_ind: string
        , setting_id: string
        , orderType: string
    ) {
        const params = {
            salesrepCode: salesrepCode
            , shiptoCode: shiptoCode
            , soldtoCode: soldtoCode
            , salesorg: salesorg
            , division: division
            , distchannel: distchannel
            , prdCode: prdCode
            , sales_ind: sales_ind
            , setting_id: setting_id
            , orderType: orderType
        };
        
        this.url = this.protocol + this.util.getWebServiceURL() + 'product/GetProductMOV';
        return this.axiosHttpRequest.get(this.url, params);
    }
}


// WEBPACK FOOTER //
// ./src/services/product.service.ts